// extracted by mini-css-extract-plugin
module.exports = {"logo":"src-views-dashboard-sub-home-fund-list-styles__logo--SBlOb"};